import * as React from "react";
import DayOfWeekSelect from "./FormComponents/DayOfWeekSelect";
import HourSelect from "./FormComponents/HourSelect";
import MinuteSelect from "./FormComponents/MinuteSelect";
import { Shift } from "./types";
import { IconTrash } from "@velaro/velaro-component-lib";

interface Props {
  shift: Shift;
  onChange: (shift: Shift) => void;
  onDelete: () => void;
}

export default function ShiftForm(props: Props) {
  // Helper function to convert hour and minute to HH:MM format
  const timeToString = (hour: number, minute: number): string => {
    const h = hour.toString().padStart(2, "0");
    const m = minute.toString().padStart(2, "0");
    return `${h}:${m}`;
  };

  // Helper function to parse HH:MM format and update shift
  const handleTimeChange = (timeString: string, isStart: boolean) => {
    const [hours, minutes] = timeString.split(":").map(Number);

    if (isStart) {
      props.onChange({
        ...props.shift,
        startHour: hours,
        startMinute: minutes
      });
    } else {
      props.onChange({
        ...props.shift,
        endHour: hours,
        endMinute: minutes
      });
    }
  };

  return (
    <div className="flex gap-3 border p-3 mb-2 items-center">
      <DayOfWeekSelect
        value={props.shift.startDayOfWeek}
        onChange={(value) =>
          props.onChange({
            ...props.shift,
            startDayOfWeek: value,
            endDayOfWeek: value
          })
        }
      />
      <span className="text-gray-600">at</span>
      <DateTimeInput
        onChange={(value) => handleTimeChange(value, true)}
        value={timeToString(props.shift.startHour, props.shift.startMinute)}
        type="time"
      />
      <span className="text-gray-600">to</span>
      <DayOfWeekSelect
        value={props.shift.endDayOfWeek}
        onChange={(value) =>
          props.onChange({ ...props.shift, endDayOfWeek: value })
        }
      />
      <span className="text-gray-600">at</span>
      <DateTimeInput
        onChange={(value) => handleTimeChange(value, false)}
        value={timeToString(props.shift.endHour, props.shift.endMinute)}
        type="time"
      />
      <button
        type="button"
        onClick={() => props.onDelete()}
        className="shift-form-text ml-auto"
        title="Delete this shift"
      >
        <IconTrash />
      </button>
    </div>
  );

  function DateTimeInput({
    type,
    label,
    value,
    onChange
  }: {
    type: string;
    label?: string;
    value: string;
    onChange: (value: string) => void;
  }) {
    return (
      <div>
        {label && <div className="text-slate-500 text-sm mb-1">{label}</div>}
        <input
          type={type}
          value={value}
          onChange={(e) => {
            onChange(e.currentTarget.value);
          }}
          className="border rounded-md p-2 w-32"
        />
      </div>
    );
  }
}
